/**
 * Maison Grès — live Google reviews (worker /reviews)
 */
(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stars(rating) {
    const n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(n);
  }

  function initials(name) {
    return String(name || 'G')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0])
      .join('')
      .toUpperCase();
  }

  async function loadReviews(root) {
    const api = (root.dataset.apiUrl || '').replace(/\/$/, '');
    const max = Math.max(1, Math.min(6, Number(root.dataset.maxReviews) || 6));
    const statusEl = root.querySelector('[data-reviews-status]');
    const gridEl = root.querySelector('[data-reviews-grid]');
    const summaryEl = root.querySelector('[data-reviews-summary]');
    const rateEl = root.querySelector('[data-reviews-rate]');
    const allEl = root.querySelector('[data-reviews-all]');

    if (!api) {
      if (statusEl) statusEl.textContent = 'Reviews API URL is missing.';
      return;
    }

    try {
      const res = await fetch(`${api}/reviews`, { credentials: 'omit' });
      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.ok) {
        throw new Error(data.error || `Could not load reviews (${res.status})`);
      }

      if (data.writeReviewUrl && rateEl) rateEl.href = data.writeReviewUrl;
      if (data.mapsUrl && allEl) allEl.href = data.mapsUrl;

      if (summaryEl) {
        const rating = data.rating != null ? Number(data.rating).toFixed(1) : '—';
        const count = data.reviewCount != null ? data.reviewCount : (data.reviews || []).length;
        summaryEl.hidden = false;
        summaryEl.innerHTML = `
          <span class="maison-reviews__stars" aria-hidden="true">${stars(data.rating)}</span>
          <strong>${escapeHtml(rating)}</strong>
          <span>· ${escapeHtml(String(count))} Google reviews</span>
        `;
      }

      const reviews = (data.reviews || []).slice(0, max);
      if (!reviews.length) {
        if (statusEl) statusEl.textContent = 'No Google reviews yet — be the first to rate us.';
        return;
      }

      if (statusEl) statusEl.hidden = true;
      if (gridEl) {
        gridEl.hidden = false;
        gridEl.innerHTML = reviews
          .map((r) => {
            const photo = r.authorPhoto
              ? `<img class="maison-reviews__avatar" src="${escapeHtml(r.authorPhoto)}" alt="" width="40" height="40" loading="lazy">`
              : `<span class="maison-reviews__avatar maison-reviews__avatar--fallback" aria-hidden="true">${escapeHtml(initials(r.author))}</span>`;
            return `
              <article class="maison-reviews__card">
                <div class="maison-reviews__card-top">
                  ${photo}
                  <div>
                    <p class="maison-reviews__author">${escapeHtml(r.author)}</p>
                    <p class="maison-reviews__meta">
                      <span class="maison-reviews__stars">${stars(r.rating)}</span>
                      ${r.relativeTime ? ` · ${escapeHtml(r.relativeTime)}` : ''}
                    </p>
                  </div>
                </div>
                <p class="maison-reviews__text">${escapeHtml(r.text)}</p>
              </article>
            `;
          })
          .join('');
      }
    } catch (err) {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = err.message || 'Unable to load Google reviews right now.';
      }
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-maison-reviews]').forEach((el) => {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      loadReviews(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
